module.exports = {
  updateModeTypes: {
    none: -1,
    currentStats: 0,
    tables: 1,
    graphs: 2,
  },
};
